export default __webpack_public_path__ + "static/media/IndotexLogo.34030cce.png";